import { client, gql } from 'data-provider';

// Stitches S6. Every operation is behind the stock.finalStockOut flag and its own permission.
export interface IFinalStockOut {
  id: string;
  quantity: number;
  stockValue: number;
  unitPurchasePrice: number;
  reason: string;
  returnCopyId?: string | null;
  finalStockOutDate: string;
  productVariant?: { id: string; name: string; sku: string } | null;
  warehouse?: { id: string; name: string } | null;
  user?: { id: string; name: string } | null;
}

export interface ICreateFinalStockOut {
  productVariantId: string;
  warehouseId: string;
  quantity: number;
  reason: string;
  returnCopyId?: string;
}

const finalStockOutFields = `
  id
  quantity
  stockValue
  unitPurchasePrice
  reason
  returnCopyId
  finalStockOutDate
  productVariant { id name sku }
  warehouse { id name }
  user { id name }
`;

export const getFinalStockOuts = async (options: {
  returnCopyId?: string;
  start?: number;
  limit?: number;
}) => {
  const query = gql`
    query ($returnCopyId: String, $start: Int, $limit: Int) {
      finalStockOuts(returnCopyId: $returnCopyId, start: $start, limit: $limit) {
        data { ${finalStockOutFields} }
        total
      }
    }
  `;
  const data = await client.request(query, options);
  return data.finalStockOuts as { data: IFinalStockOut[]; total: number };
};

export const createFinalStockOut = async (input: ICreateFinalStockOut) => {
  const mutation = gql`
    mutation ($input: CreateFinalStockOutInput!) {
      createFinalStockOut(input: $input) { ${finalStockOutFields} }
    }
  `;
  const data = await client.request(mutation, { input });
  return data.createFinalStockOut as IFinalStockOut;
};

// Puts the written-off stock back on hand, the way deleting a damage does.
export const deleteFinalStockOut = async (id: string) => {
  const mutation = gql`
    mutation ($input: DeleteFinalStockOutInput!) {
      deleteFinalStockOut(input: $input) {
        id
      }
    }
  `;
  await client.request(mutation, { input: { id } });
};
